class ComponentVideo {
  constructor() {
    this._init();
  }

  _init() {
    const videoContainers: NodeListOf<HTMLDivElement> = document.querySelectorAll('.video-container');

    videoContainers.forEach((container) => {
      const video: HTMLVideoElement | null = container.querySelector('video');
      const playButton: HTMLButtonElement | null = container.querySelector('.video-container__button');

      if (video && playButton) {
        playButton.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            playButton.classList.add('hidden');
          } else {
            video.pause()
            playButton.classList.remove('hidden');
          }
        });

        video.addEventListener('click', () => {
          if (video.paused) {
            playButton.classList.add('hidden');
          } else {
            playButton.classList.remove('hidden');
          }

        });
        video.addEventListener('play', () => {
          playButton.classList.add('hidden');
        });

        video.addEventListener('pause', () => {
          playButton.classList.remove('hidden');
        });
        video.addEventListener('ended', () => {
          playButton.classList.remove('hidden');
        });
      }
    });
  }

}

export const componentVideo = new ComponentVideo();
